import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledSelectItem = styled(Flex)<{ $selected: boolean }>`
  width: 100%;
  height: 100%;

  .label-item {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    font-weight: ${props => (props.$selected ? '600' : '400')};
  }
`;
